export const parseFrontmatter = (fileContent: string) => {
  const match = /^---\s*[\r\n]+([\s\S]+?)[\r\n]+---/.exec(fileContent);
  const frontmatter: Record<string, any> = {};
  let content = fileContent;

  if (match) {
    const frontmatterBlock = match[1];
    content = fileContent.replace(match[0], '').trim();

    frontmatterBlock.split(/[\r\n]+/).forEach((line) => {
      if (!line.trim()) return;

      const parts = line.split(':');
      if (parts.length < 2) return;

      const key = parts[0].trim();
      let value = parts.slice(1).join(':').trim();

      if (
        (value.startsWith('"') && value.endsWith('"')) ||
        (value.startsWith("'") && value.endsWith("'"))
      ) {
        value = value.slice(1, -1);
      }

      if (value.startsWith('[') && value.endsWith(']')) {
        frontmatter[key] = value
          .slice(1, -1)
          .split(',')
          .map((s: string) => s.trim().replace(/['"]/g, ''))
          .filter(Boolean);
      } else {
        frontmatter[key] = value;
      }
    });
  }

  return { frontmatter, content };
};
